import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import { REQUEST_STATUS_COMPLETED } from '../../../../share/util/api/polling';
import { PHASE, READ_RESULT_TYPE } from './constants';

/** データ読出し処理 
 * @param {instance} self 呼び出し元インスタンス
 */
export async function readData(self) {
  try {
    self.isLoading = true;

    // バックエンドAPI POST,GET
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'read'
      },
      // エラー発生のコールバックを実装
      // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
    );

    if (!response) return;

    if (response.data.status === REQUEST_STATUS_COMPLETED) {
      switch (response.data.user_data.result) {
        // GPF強制再生確認表示へ遷移
        case READ_RESULT_TYPE.FORCE:
          self.phase = PHASE.STANDBY_FORCED_PLAYBACK;
          break;
        // GPF再生確認表示へ遷移
        case READ_RESULT_TYPE.NORMAL:
          self.phase = PHASE.STANDBY_PLAYBACK;
          break;
        // 開始条件不成立表示へ遷移
        case READ_RESULT_TYPE.NG:
          self.phase = PHASE.START_CONDITION_ERROR;
          break;
        // 上記以外：共通エラーへ遷移  
        case READ_RESULT_TYPE.OTHER:
        default:
          await self.showUnexpectedError();
          return;
      }
    } else {
      // 異常終了：共通エラーへ遷移  
      await self.showUnexpectedError();
    }
  } finally {
    self.isLoading = false;
  }
}
